const setupPageViewTracker = (callback) => {
  const handlePageView = () => {
    callback(document.location.pathname);
  };

  handlePageView();

  let history = window.history;

  if (history.pushState) {
    const originalPushState = history.pushState;
    history.pushState = function () {
      originalPushState.apply(this, arguments);
      handlePageView();
    };

    window.addEventListener("popstate", handlePageView);
  }
};

const setupClickTracker = (callback, tags = ["BUTTON", "A"]) => {
  const trackElement = async (el) => {
    await callback({
      text: el.innerText,
      elementId: el.id || "",
      elementType: el.tagName,
      htmlId: el.getAttribute("id") || "",
      outboundUrl: el.getAttribute("href") || "",
    });
  };

  const handleClick = (e) => {
    const findATagParent = (rootElem, maxSearchDepth) => {
      let currentElement = rootElem;
      for (let i = 0; i < maxSearchDepth; i++) {
        if (currentElement.tagName === "A") {
          return currentElement;
        }
        currentElement = currentElement.parentElement;
        if (!currentElement) {
          return null;
        }
      }
      return null;
    };

    const el = e.target;
    const anchor = el.tagName === "A" ? el : findATagParent(el, 10);

    if (anchor) {
      const { href, target } = anchor;
      const external =
        target === "_blank" ||
        e.ctrlKey ||
        e.shiftKey ||
        e.metaKey ||
        (e.button && e.button === 1);

      if (href) {
        if (!external) {
          e.preventDefault();
        }

        return trackElement(anchor).then(() => {
          if (!external) location.href = href;
        });
      }
    } else if (tags.includes(el.tagName)) {
      trackElement(el);
    }
  };

  document.addEventListener("click", handleClick, true);
};

const setupScrollTracker = (callback, thresholds) => {
  let triggered = [];

  const handleScroll = () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;
    const scrollPercent = (scrollPosition / docHeight) * 100;

    thresholds.forEach((threshold) => {
      if (scrollPercent >= threshold && !triggered.includes(threshold)) {
        triggered.push(threshold);
        callback({
          scrollDistance: threshold,
        });
      }
    });
  };

  window.addEventListener("scroll", handleScroll);
};

const Analytics = {
  initialize(callbacks, config) {
    setupPageViewTracker(callbacks.pageView);
    setupClickTracker(callbacks.click, config.clickTags);
    setupScrollTracker(callbacks.scroll, config.scrollThresholds);
  },
};

export default Analytics;
